const LogFilesDemoData = [
    {
        name: 'Error_Critical_2024-02-05_11.log',
        size: 19870,
        created: 1707131203,
        demo: true
    },
    {
        name: 'Imported_Customer_Log_2024-02-05_10.xlsx',
        size: 2845,
        created: 1707129726,
        demo: true
    }
];

export default LogFilesDemoData;
